import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/raw/gradient.svg'


const _withScopeId = n => (_pushScopeId("data-v-52554152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "background",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "title" }, "TRASHABLE", -1))
const _hoisted_5 = {
  id: "user-logo",
  class: "logo"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Catre site")

import DiscordSignIn from '@/components/modules/account/DiscordSignIn.vue';
import GoogleSignIn from '@/components/modules/account/GoogleSignIn.vue';
import Button from '@/components/ui/Button.vue';
import ReturnButton from '@/components/ui/ReturnButton.vue';
import TrashableLogo from '@/components/icons/TrashableLogo.vue';
import UserLogo from '@/components/icons/UserLogo.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TrashableLogo)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(UserLogo)
    ]),
    _createVNode(GoogleSignIn, { class: "button-login" }),
    _createVNode(DiscordSignIn, { class: "button-login" }),
    _createVNode(Button, {
      size: "normal",
      id: "to-site"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(ReturnButton)
  ]))
}
}

})